import React from 'react';
import PriceGenerator from './prices';

import './price.less';

function Price({
  priceNet,
  priceRrp,
  isCustomization,
  isTotal,
  isTeamSport,
  currency,
  isCheckout
}) {
  const discountColor = isCheckout ? 'black' : 'orange';
  if (isCustomization) {
    return (
      <span className="price_wrapper">
        <span
          className={`noBreak ${
            priceNet.lessThan(priceRrp) ? discountColor : 'lightGrey'
          }`}
        >
          {priceNet.toString()}
        </span>
        {priceNet.lessThan(priceRrp) && (
          <span className="lineThrough noBreak lightGrey">
            {priceRrp.toString()}
          </span>
        )}
      </span>
    );
  }

  if (isTotal) {
    if (isTeamSport) {
      const price = new PriceGenerator(priceNet, currency);
      return <span className="price_wrapper">{price.toString()}</span>;
    }
    return (
      <span className="price_wrapper">
        <strong className="black">{priceNet.toString()}</strong>
      </span>
    );
  }

  let oldPriceComp = null;
  let discountStyle = 'darkGrey';
  let pNet = 0;
  if (isTeamSport) {
    const rrp = new PriceGenerator(priceRrp, currency);
    pNet = new PriceGenerator(priceNet, currency);
    if (priceNet < priceRrp) {
      oldPriceComp = (
        <>
          {' '}
          <span className="lineThrough noBreak greyedOut">
            {rrp.toString()}
          </span>
        </>
      );
      discountStyle = discountColor;
    }
  } else if (priceNet.lessThan(priceRrp)) {
    oldPriceComp = (
      <>
        {' '}
        <span className="lineThrough noBreak greyedOut">
          {priceRrp.toString()}
        </span>
      </>
    );
    discountStyle = discountColor;
  }

  return (
    <span className="price_wrapper">
      <span className={`noBreak ${discountStyle}`}>
        {isTeamSport ? pNet.toString() : <strong>{priceNet.toString()}</strong>}
      </span>
      {oldPriceComp}
    </span>
  );
}

export default Price;
